<template>
  <div class="webrtc_face_recognition" :key="refresh" v-loading='loading' style="text-align:left">
    <div class="see">
      <video
        id="myVideo"
        playsinline
        height="500px"
        width="500px"
        @loadedmetadata="fnRun"
      ></video>
      <canvas id="myCanvas" width="500" height="500"></canvas>
      <img v-if="imgshow" class="image" :src="imgsrc" alt="">
    </div>
    <div class="iconclose"><i class="el-icon-error" style="font-size:50px" @click="close"></i></div>
  </div>
</template>

<script>
export default {
  name: "WebRTCFaceRecognition",
  inject:['close'],
  data() {
    return {
      loading:true,
      refresh:0,
      imgshow:false,
      imgsrc:'',
      videoEl: null,
      canvasEl: null,
      timeout: 0,
      timer:null,
      // 视频媒体参数配置
      constraints: {
        audio: false,
        video: {
          width: {
            min: 500,
            ideal: 500,
            max: 500,
          },
          height: {
            min: 500,
            ideal: 500,
            max: 500,
          },
          // frameRate受限带宽传输时，低帧率可能更适宜
          frameRate: {
            min: 15,
            ideal: 30,
            max: 60,
          }
          // facingMode:  { exact: "user" }
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      if(navigator.mediaDevices){
        this.fnOpen()
        this.fnInit();
      }
    });
  },
  methods: {
    getImg(canvasEl){
      // canvasEl.width = this.videoEl.videoWidth;
      // canvasEl.height = this.videoEl.videoHeight;
      console.log(this.imgsrc)
      setTimeout(() => {
        canvasEl.getContext("2d").drawImage(this.videoEl, 0, 0);
        this.imgsrc = canvasEl.toDataURL("image/png");
        //this.fnClose();
        //this.imgshow = true
        // clearTimeout(this.timer)
        this.$emit('update',this.imgsrc)
      },300)
    },
    // 初始化模型加载
    async fnInit() {
      await faceapi.nets['tinyFaceDetector'].loadFromUri("../../../static/models"); // 算法模型
      await faceapi.loadFaceLandmarkModel("../../../static/models"); // 轮廓模型
      // 节点属性化
      this.videoEl = document.getElementById("myVideo");
      this.canvasEl = document.getElementById("myCanvas");
    },
    // 人脸面部勘探轮廓识别绘制
    async fnRunFaceLandmark() {
      this.loading = false
      if (this.videoEl.paused) return clearTimeout(this.timeout);
      // 识别绘制人脸信息
      const result = await faceapi['detectSingleFace'](
        this.videoEl,
        new faceapi.TinyFaceDetectorOptions({
          inputSize: 160, // 160 224 320 416 512 608
          scoreThreshold: 0.5, // 0.1 ~ 0.9
        })
      ).withFaceLandmarks();
      // if (result && !this.videoEl.paused)
      if (result && !this.videoEl.paused) {
        const dims = faceapi.matchDimensions(this.canvasEl, this.videoEl, true);
        const resizeResult = faceapi.resizeResults(result, dims);
        faceapi.draw.drawDetections(this.canvasEl, resizeResult)
        this.videoEl.pause()
        // if(!this.timer){
          //this.timer = setTimeout(() => {
        //     // 截图
            this.getImg(this.canvasEl)
          //},300)
        // }
      } else {
        // clearTimeout(this.timer)
        // this.timer = null
        this.canvasEl
          .getContext("2d")
          .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
      }
      this.timeout = setTimeout(() => this.fnRunFaceLandmark());
    },
    // 执行检测识别类型
    fnRun() {
      this.fnRunFaceLandmark();
    },
    // 启动摄像头视频媒体
    fnOpen() {
      // this.imgshow = false
      if (typeof window.stream === "object") return;
      clearTimeout(this.timeout);
      //this.timeout = setTimeout(() => {
        //clearTimeout(this.timeout);  
        if(navigator.mediaDevices){
          navigator.mediaDevices
            .getUserMedia(this.constraints)
            .then(this.fnSuccess)
            .catch(this.fnError);
        }
      //}, 300);
    },
    // 成功启动视频媒体流
    fnSuccess(stream) {
      window.stream = stream; // 使流对浏览器控制台可用
      this.videoEl.srcObject = stream;
      this.videoEl.play();
    },
    // 失败启动视频媒体流
    fnError(error) {
      console.log(error);
    },
    // 结束摄像头视频媒体
    fnClose() {
      this.canvasEl
        .getContext("2d")
        .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
      this.videoEl.pause();
      clearTimeout(this.timeout);
      if (typeof window.stream === "object") {
        window.stream.getTracks().forEach((track) => track.stop());
        window.stream = "";
        this.videoEl.srcObject = null;
      }
    },
  },
  beforeDestroy() {
    this.fnClose();
  },
};
</script>

<style scoped>
.webrtc_face_recognition{
  position: relative;
  text-align:left!important;
}
button {
  height: 30px;
  border: 2px #42b983 solid;
  border-radius: 4px;
  background: #42b983;
  color: white;
  margin: 10px;
}
.see {
  position: relative;
  transform: rotateY(180deg);
}
.see canvas {
  position: absolute;
  top: 0;
  left: 0;
}
.option {
  padding-bottom: 20px;
}
.option div {
  padding: 10px;
  border-bottom: 2px #42b983 solid;
}
.option div label {
  margin-right: 20px;
}
.image{
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  width: 500px;
  height: 500px;
  /* transform: rotateY(180deg); */
}
.videoBox{
  width: 500px;
  height: 500px;
  position: absolute;
  top: 0;
  left: 0;
  background:
      linear-gradient(#03a9f4, #03a9f4),
      linear-gradient(90deg, #ffffff33 1px, transparent 0, transparent 19px),
      linear-gradient(#ffffff33 1px, transparent 0, transparent 19px),
      linear-gradient(transparent, #2196f3);
  background-size: 100% 1.5%, 10% 100%,100% 10%, 100% 100%;
  background-repeat: no-repeat, repeat, repeat, repeat;
  background-position: 0 0, 0 0, 0 0, 0 0;
  clip-path: polygon(0% 0%, 100% 0%, 100% 1.5%, 0% 1.5%);
  animation: move 1.5s linear infinite;
}
@keyframes move {
  to {
    background-position: 0 100%, 0 0, 0 0, 0 0;
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
}
#myVideo{
  /* transform: rotateY(180deg); */
}
.iconclose{
  position: absolute;
  top: 0;
  right: 0;
}
#myCanvas{
  height: 500px!important;
  width:500px!important;
}
#Canvas{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/faceapi/WebRTCFaceRecognition.vue